import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Table,
} from "reactstrap";
import { get, put, del } from "helpers/api_helper";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
// import "./datatables.scss"

//i18n
import { withTranslation } from "react-i18next";
import { ModalAddCutoff } from "./Components";
import { useLocation } from "react-router-dom";
import Pagination from "pages/Master-Data/Component/Student/Pagination";
import LoadingSpinner from "components/Common/LoadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";
//redux
import { useSelector } from "react-redux"

const CutoffProps = props => {
  // Table Data
  const profile = useSelector(state => state.Profile.profile)
  const [ dataCutoff, setDataCutoff ] = useState([]);
  const [ dataCutoffFiltered, setDataCutoffFiltered ] = useState([]);
  const [ currentPage, setCurrentPage ] = useState(1);
  const [ dataPerPage, setDataPerPage ] = useState(10);
  const [ filter,setFilter ] = useState({key:''});
  const [ isLoading, setIsloading ] = useState(false);

  const [modalAddCutoff, setmodalAddCutoff] = useState(false);
  const [error_alert, seterror_alert] = useState(false);
  //confirmation alert
  const [confirmAlert, setConfirmAlert] = useState(null);
  const [confirmAction, setConfirmAction] = useState(null); 
  const [successAlert, setSuccessAlert] = useState(false);
  const [failedAlert, setFailedAlert] = useState(false);
  //alert data
  const [confimMsg, setConfirmMsg] = useState("")
  const [successMsg, setSuccessMsg] = useState("")
  const [failedMsg, setFailedMsg] = useState("")

  const toggleModal = () => setmodalAddCutoff(!modalAddCutoff);
 
  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search),[search])
  }

  let query = useQuery();

  const getDataCutoff = async ()=> {
    setIsloading(true);
    try {
      let response = await get("/early-dismissal/cutoffs");
      let data = response.data;
      const map = data.map((item, index) => {
        let id = item.id
        let code_id;
        switch(item.school_id){
          case 100:
          case 1061:
            code_id = 'Nursery'; break;
          case 101:
          case 1062:
            code_id = 'Kindergarten'; break;
          case 102:
          case 1063:
            code_id = 'Primary'; break;
          case 105:
            code_id = 'Tokyo'; break;
        }
        let is_active = `${item.is_active}`;
        let cutoff_time = item.cutoff_time;
        let grade_level = item.grade_level;
        const identifier = grade_level.slice(0,1)
        if(identifier == 2) grade_level = grade_level.slice(1) + ' PIK 2'
        else grade_level = grade_level + ' PIK 1'
        let keyExtractor = `${id}-${code_id}-${grade_level}-${is_active}-${cutoff_time}`.toLowerCase();
        return { 
          id: id , 
          code_id: code_id, 
          cutoff_time:cutoff_time, 
          is_active: is_active,
          grade_level: grade_level,
          keyExtractor: keyExtractor,
        };
      });
      
      // const sortedData = map.sort((a,b)=>a.id - b.id);
      const searchQuery = query.get('grade_level');
      if(searchQuery){
        const filteredCutoff = map.filter(x => x.grade_level === searchQuery);
        setDataCutoff(filteredCutoff);
        setDataCutoffFiltered(filteredCutoff);
      } else {
        setDataCutoff(map);
        setDataCutoffFiltered(map);
      }
    } catch (error) {
      seterror_alert(true);
    }
    setIsloading(false);
  }

  const handleUpdateActive = async (item) => {
    const newStatus = item.is_active === "true" ? false : true;

    setIsloading(true);
    try {
      await put(`/early-dismissal/cutoffs/${item.id}`, {
        is_active: newStatus,
      });
      setIsloading(false);
      setSuccessMsg("Status updated successfully")
      // refresh data
      getDataCutoff()
      setSuccessAlert(true);
    } catch (err) {
      setFailedMsg("Failed to update status")
      setIsloading(false);
      setFailedAlert(true);
    }
  };

  const handleDelete = async (item) => {

    setIsloading(true);
    try {
      await del(`/early-dismissal/cutoffs/${item.id}`);
      setIsloading(false);
      setSuccessMsg("Delete data successfully")
      // refresh data
      getDataCutoff()
      setSuccessAlert(true);
    } catch (err) {
      setFailedMsg("Failed to delete data")
      setIsloading(false);
      setFailedAlert(true);
    }
  };

  useEffect (()=>{
    getDataCutoff()
  }, []);

  useEffect(()=>{
    setCurrentPage(1);
    const newData = dataCutoff.filter(item => {
      return ((filter?.key) ? (item.keyExtractor.includes(filter.key.toLowerCase())) : true);
    })
    setDataCutoffFiltered(newData)
  },[filter]);

  const header = ["No","Grade","Level","Cutoff Time","status","Action"];

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = dataCutoffFiltered.slice(indexOfFirstData, indexOfLastData);

  const paginate = pageNumber => setCurrentPage(pageNumber);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
            <title>Tzu Chi</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
              title={props.t("Cutoff")}
              breadcrumbItem={props.t("Early Dismissal")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle className="h4">Cutoff Management</CardTitle>
                  <p className="card-title-desc"></p>

                  <Row className="my-2">
                    <Col md="6">
                        <div className="search-box me-2 mb-3 d-flex justify-content-start">
                          {profile && (
                            <Button
                              color="primary"
                              onClick={toggleModal}
                              className="btn-sm m-1"
                            >
                              <i className="bx bx-plus"></i>
                              Add Cutoff Data
                            </Button>
                          )}
                        </div>
                      </Col>
                    <Col md="6" className="mt-2">
                      <div className="search-box me-2 mb-3 d-flex justify-content-end">
                        <div className="position-relative ">
                          <input className="form-control" type="text" placeholder="Search level" value={filter.key} onChange={item=> setFilter({...filter,key:item.target.value})}/>
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <div className='table-responsive'>
                    <Table className='table'>
                      <thead>
                          <tr>
                            {header.map((x, index) => (
                              <th key={`head-${index}`}>{x}</th>
                            ))}
                          </tr>
                      </thead>
                      <tbody>
                        {isLoading ? 
                            <tr>
                              <td colSpan={6}>
                                <div className="d-flex flex-column align-items-center justify-content-center py-4">
                                  <LoadingSpinner />
                                  <div className="mt-2">Fetching data, please wait...</div>
                                </div>
                              </td>
                            </tr>
                          : currentData.length > 0 ?
                          currentData.map((e,index) => {
                              return(
                                <React.Fragment key={`${e.id}-${index}`}>
                                  <tr>
                                    <td>{index + 1 || ""}</td>
                                    <td>{e?.code_id || ""}</td>
                                    <td>{e?.grade_level || ""}</td>
                                    <td>{e?.cutoff_time || ""}</td>
                                    <td>
                                      <i
                                        className={`bx ${
                                          e.is_active === "true"
                                            ? "bx-toggle-right text-success"
                                            : "bx-toggle-left text-secondary"
                                        }`}
                                        style={{ fontSize: "32px", cursor: "pointer" }}
                                        onClick={() => {
                                          setConfirmAlert(e);
                                          setConfirmAction("update");
                                          setConfirmMsg(
                                            e.is_active === "true"
                                              ? "Deactivate this data?"
                                              : "Activate this data?"
                                          );
                                          
                                        }}
                                      ></i>
                                    </td>
                                    <td>
                                      <i className="bx bx-trash text-danger"
                                       style={{ fontSize: "24px", cursor: "pointer" }}
                                       onClick={() => {
                                          setConfirmAlert(e);
                                          setConfirmAction("delete");
                                          setConfirmMsg("Delete this data?");
                                        }}
                                      ></i>
                                    </td>
                                    
                                  </tr>
                                </React.Fragment>
                              )
                            })
                          :
                          <tr>
                            <td colSpan={5} className="text-center">No Data</td>
                          </tr>
                        }
                      </tbody>
                    </Table>
                  </div>
                  <Pagination
                    setDataPerPage={setDataPerPage}
                    dataPerPage={dataPerPage}
                    totalData={dataCutoffFiltered.length}
                    paginate={paginate}
                    currentPage={currentPage}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ModalAddCutoff 
          modalShow={modalAddCutoff} 
          toggleModal={toggleModal} 
          profile={profile}
          onSuccess={getDataCutoff}
        />
        { error_alert ?
            <SweetAlert
                title="Oppss!"
                confirmBtnText="Yes"
                error
                confirmBtnBsStyle="primary"
                onConfirm={() => {
                    seterror_alert(false)
                }}
            >
                Something wrong, please try again
            </SweetAlert>
        : null }
        {confirmAlert && (
          <SweetAlert
            warning
            showCancel
            confirmBtnText="Yes"
            cancelBtnText="Cancel"
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="secondary"
            title="Are you sure?"
            onConfirm={() => {
              if (confirmAction === "update") {
                handleUpdateActive(confirmAlert);
              }
              if (confirmAction === "delete") {
                handleDelete(confirmAlert);
              }
              setConfirmAlert(null);
              setConfirmAction(null);
            }}
            onCancel={() => {
              setConfirmAlert(null);
              setConfirmAction(null);
            }}
          >
            {confimMsg}
          </SweetAlert>
        )}
        {successAlert && (
          <SweetAlert
            success
            title="Success"
            onConfirm={() => setSuccessAlert(false)}
          >
            {successMsg}
          </SweetAlert>
        )}

        {failedAlert && (
          <SweetAlert
            error
            title="Failed"
            onConfirm={() => setFailedAlert(false)}
          >
            {failedMsg}
          </SweetAlert>
        )}

      </div>
    </React.Fragment>
  );
};

CutoffProps.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(CutoffProps);
